/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

export const getStatsEarlyRequestRpc = {
  serviceName: 'com.hubspot.marketing.email.reports.rpc.postsend.PostSendStatsRpc',
  rpcName: 'getStats',
  auth: 'app',
  fingerprint: '7moWeAOIG3PzE3WBj9Rc2y0MT8iC4-SF',
  earlyRequest: true
};
export const getStatsForInitialLoadEarlyRequestRpc = {
  serviceName: 'com.hubspot.marketing.email.reports.rpc.postsend.PostSendStatsRpc',
  rpcName: 'getStatsForInitialLoad',
  auth: 'app',
  fingerprint: 'ilrhg8sFzobgffdg2YdH8y0MT8iC4-SF',
  earlyRequest: true
};